import React from "react";
import { View, Dimensions, StyleSheet } from "react-native";
import { colors, global } from "../../const";
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

function ButtonGroupComponent({ buttons, selectedIndex, onPress }) {

    const onChangeIndex = (index) => {
        onPress(index)
    }

    return (
        <ButtonGroup
            fullWidth
        >
            {
                buttons.map((item, i) => (
                    <Button
                        onClick={() => onChangeIndex(i)}
                        key={i}
                        style={{ backgroundColor: i === selectedIndex ? colors.indigo : "transparent", height: 45, color: i === selectedIndex ? colors.white : colors.gray, fontFamily: global.FONT_REGULAR }}
                    >{item}</Button>
                ))
            }
        </ButtonGroup>
    )

}

export default ButtonGroupComponent;

const pageStyles = StyleSheet.create({
    
})